import deviceDictionary from "./devices/dictionary";
import deviceList from "./devices/list";
import deviceProductsNormalizer from "./devices/products";
import deviceInfoNormalizer from "./devices/device-info";
import productsNormalizer from "./products";

function normalizeDeviceDictionary(data, offer) {
  const products = deviceDictionary(data.products, offer);

  return products;
}

function normalizeDeviceList(data, clientType) {
  const list = deviceList(data, clientType);

  return list;
}

function normalizeProducts(data) {
  const productState = productsNormalizer(data.sections);

  return productState;
}

function normalizeDeviceInfo(data) {
  const deviceData = deviceInfoNormalizer(data);

  return deviceData;
}

function normalizeDeviceProduct(data) {
  const deviceProducts = deviceProductsNormalizer(data);

  return deviceProducts;
}

export {
  normalizeDeviceDictionary,
  normalizeDeviceList,
  normalizeProducts,
  normalizeDeviceProduct,
  normalizeDeviceInfo,
};
